module.exports = "<ng-material-multilevel-menu [items]='appitems' (selectedItem)=\"redirect($event)\"></ng-material-multilevel-menu>"